





























































import {
  defineComponent,
  computed,
  useRouter,
  ref,
  watch,
  onMounted,
} from "@nuxtjs/composition-api";
import { useUiState, useVoucher } from "~/composables";
import { useUser } from "~/modules/customer/composables/useUser";
import { Voucher } from "~/composables/useVoucher/useVoucher";
import VoucherItem from "~/components/vouchers/VoucherItem.vue";
import VoucherDetailModal from "~/components/vouchers/VoucherDetailModal.vue";
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import { useVoucherStore } from "~/stores/extensionApi";
import { useUiNotification } from "~/composables";

SwiperCore.use([Navigation, Pagination]);

export default defineComponent({
  name: "CollectVoucher",
  components: {
    VoucherItem,
    VoucherDetailModal,
    Swiper,
    SwiperSlide,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    location: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const router = useRouter();
    const { user, load: loadUser, isAuthenticated } = useUser();
    const { send: sendNotification } = useUiNotification();
    const {
      load: loadVouchers,
      post: postVoucher,
      vouchers: vouchers,
    } = useVoucher();
    const { toggleLoginModal } = useUiState();
    const rule_ids = props?.item?.rule_ids ?? "";
    const customerId = computed(() => user.value?.customer_id);
    const itemsDetail = ref(<Voucher>null);
    const isModalVoucher = ref(false);
    const voucherStore = useVoucherStore();

    const listVoucher = ref<Voucher[]>([]);

    const Option3Item = {
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      spaceBetween: 12,
      slidesPerColumn: 2,
      slidesPerColumnFill: "row",
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      scrollbar: { draggable: true },
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: "auto",
          slidesPerGroup: 3,
          spaceBetween: 12,
        },
        1024: {
          slidesPerView: "auto",
          slidesPerGroup: 4,
          spaceBetween: 16,
          slidesPerColumn: 1,
        },
      },
    };
    const Option4Item = {
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      spaceBetween: 7,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 11,
        },
        768: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 11,
        },
        1024: {
          slidesPerView: 3.2,
          slidesPerGroup: 2,
          spaceBetween: 14,
        },
      },
    };

    const setVoucher = async () => {
      if (!rule_ids || rule_ids?.length == 0) {
        return;
      }
      const param = customerId.value
        ? `?rule_ids=${rule_ids}&customer_id=${customerId.value}`
        : `?rule_ids=${rule_ids}`;
      await loadVouchers(param);
      listVoucher.value = vouchers.value || [];
    };
    onMounted(async () => {
      await setVoucher();
    });

    watch(
      () => customerId.value,
      async (newVal, oldVal) => {
        if (newVal !== oldVal) {
          await setVoucher();
        }
      },
      { immediate: true }
    );

    const change = (data: Voucher) => {
      itemsDetail.value = data;
      isModalVoucher.value = true;
    };

    const saveVoucher = async (data: Voucher) => {
      if (!isAuthenticated.value) {
        toggleLoginModal();
        return;
      } else {
        itemsDetail.value = data;
        let dataPost = {
          customerId: customerId.value,
          couponCode: data?.counpon_code,
          ruleId: data?.rule_id,
        };
        let response = await postVoucher(dataPost);
        if (response && response?.coupon_code) {
          voucherStore.resetVoucherDataStore();

          sendNotification({
            id: Symbol("save_voucher_success"),
            message: "Lưu mã thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Lưu mã thành công!",
          });

          isModalVoucher.value = false;
          if (itemsDetail.value) {
            itemsDetail.value.is_collect = true;
          }
          // Todo: Logic khác
        }
      }
    };

    const gotoVouchers = () => {
      router.push("/vouchers");
      voucherStore.setRuleId(rule_ids);
      localStorage.setItem(`ruleIdVouchers`, rule_ids);
    };

    return {
      listVoucher,
      Option3Item,
      Option4Item,
      itemsDetail,
      change,
      isModalVoucher,
      saveVoucher,
      gotoVouchers,
    };
  },
});
